import React, { useEffect, useRef, useState } from 'react';

const YouTubePlayer = ({ videoId, onTimeUpdate, onReady, onError, autoPlay = false }) => {
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Load YouTube IFrame API if not already loaded
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Set up the callback for when the API is ready
      window.onYouTubeIframeAPIReady = () => {
        initializePlayer();
      };
    } else {
      initializePlayer();
    }

    function initializePlayer() {
      if (containerRef.current && videoId) {
        playerRef.current = new window.YT.Player(containerRef.current, {
          height: '100%',
          width: '100%',
          videoId: videoId,
          playerVars: {
            enablejsapi: 1,
            origin: window.location.origin,
            rel: 0,
            modestbranding: 1,
            autoplay: autoPlay ? 1 : 0,
          },
          events: {
            onReady: (event) => {
              setIsReady(true);
              if (onReady) onReady(event);
              if (autoPlay && event?.target) {
                try {
                  event.target.playVideo();
                } catch (_) {}
              }
              
              // Start time tracking
              const interval = setInterval(() => {
                if (playerRef.current && playerRef.current.getCurrentTime) {
                  const currentTime = playerRef.current.getCurrentTime();
                  if (onTimeUpdate) onTimeUpdate(currentTime);
                }
              }, 100); // Update every 100ms for smooth annotation display

              // Store interval reference for cleanup
              playerRef.current.timeInterval = interval;
            },
            onError: (event) => {
              if (onError) onError(event);
            },
            onStateChange: (event) => {
              // Optional: Handle state changes (play, pause, etc.)
            }
          }
        });
      }
    }

    return () => {
      // Cleanup
      if (playerRef.current && playerRef.current.timeInterval) {
        clearInterval(playerRef.current.timeInterval);
      }
      if (playerRef.current && playerRef.current.destroy) {
        playerRef.current.destroy();
      }
    };
  }, [videoId, onTimeUpdate, onReady, onError, autoPlay]);

  return (
    <div 
      ref={containerRef}
      style={{ 
        width: '100%', 
        height: '100%',
        minHeight: '400px',
        borderRadius: '8px',
        overflow: 'hidden'
      }}
    />
  );
};

export default YouTubePlayer;
